import remote from './remote'

const URL = {
    GET_RESOLUTION: '/cms/code/resolution'
}

export default {
    getResolution (type) {
        return remote.request({
            url: `${remote.getUrl(URL.GET_RESOLUTION)}?layoutType=${type}`
        })
    }
}
